import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import BulkProductCreateForm from "./-form";
import { BulkProductCrumbs } from "./-crumbs";

export const Route = createFileRoute(
  "/_private/_practice-360/bulk-product/create",
)({
  component: BulkProductCreatePage,
});

function BulkProductCreatePage() {
  return (
    <div>
      <title>Create Bulk Product - Legrande Health Portal</title>
      <BulkProductCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Add Bulk Product</CardTitle>
          <CardDescription>Enter product details below.</CardDescription>
        </CardHeader>
        <CardContent>
          <BulkProductCreateForm />
        </CardContent>
      </Card>
    </div>
  );
}
